import { useIsMutating } from 'react-query';
import { Link } from 'react-router-dom';
import useQueryParams from 'utils/useQueryParams';
import ListingLayout from 'components/Layout/ListingLayout';
import ROUTES from 'app/routes';
import Table from 'pages/ContentPages/Listing/components/Table';
import Footer from 'components/Footer';
import LoadingIndicator from 'components/LoadingIndicator';
import { useGetContentPages } from 'api/contentPages';

function ContentPages() {
  const { queryString } = useQueryParams({
    page_size: '10',
    page: '1',
  });

  const isMutating = !!useIsMutating({
    mutationKey: ['contentPagesMutation'],
  });

  const {
    isFetching,
    data: { data: contentPages, totals } = { data: [], totals: 0 },
  } = useGetContentPages(queryString);

  const showLoading = isMutating || isFetching;

  return (
    <ListingLayout
      title="Kontent"
      headerButtons={[
        {
          label: 'NOWA STRONA',
          as: Link,
          to: ROUTES.contentPages.create,
        },
      ]}
    >
      {showLoading && <LoadingIndicator />}
      {!showLoading && <Table data={contentPages} />}
      <Footer totals={totals} footerButtons={null} />
    </ListingLayout>
  );
}

export default ContentPages;
